import FooterTwo from "./footer"
import Header from "../layout/header"
import { ReactNode } from "react"
import { Poppins } from "next/font/google"
import { usePathname } from "next/navigation";
import 'bootstrap/dist/css/bootstrap.min.css'

const poppins = Poppins({
  subsets: ["latin"],
  weight: ["400", "500", "600", "700"], 
})

const Layout = ({ children }: { children: ReactNode }) => {
  const pathname = usePathname();

  // Add all routes where footer should be hidden
  const hideFooterRoutes = ["/enquiryPage","/applicationTracker"];

  const shouldHideFooter = hideFooterRoutes.includes(pathname);
  return (
    <>
    <div className={poppins.className}>
         <Header />  
               {children}
                {!shouldHideFooter && (
      <FooterTwo />
      )}
         
    </div>
    </>
  )
}                                                                                                                                                          

export default Layout
